import { useClickOutside } from "stimulus-use";
import { Slideover } from "tailwindcss-stimulus-components";

export default class SidebarController extends Slideover {
  connect() {
    super.connect();
    useClickOutside(this);
  }
}
